import React from 'react';

import OrderSearchForm from '../../interface/Order/OrderSearchForm';
import OrderList from '../../components/ProfileOrder/OrderList';

import { OrderLoc } from '../../loc/order';
import { loc } from '../../lib/loc';

import { H4 } from '../../components/Header';

export default function Orders() {
    return (
        <>
            <H4>{loc(OrderLoc.searchOrderButton)}</H4>
            <OrderSearchForm />

            <H4>{loc(OrderLoc.allOrders)}</H4>
            <OrderList />
        </>
    );
}
